import { Injectable } from "@angular/core";
import { AppUserAuth } from "../models/user.model";
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SessionContextService {
  private readonly _VERSION = "2.0.0 - alpha7";

  public sessionUser: AppUserAuth;
  public sessionToken: string;
  public userClaims: string[];
  public loadedData: boolean;
  public smallScreen: boolean;
  public pendingNotifications = new BehaviorSubject<Array<any> | null>(null);
  public pendingNotificationsObservable$ = this.pendingNotifications.asObservable();
  public notificationIdOnInit: number | null;

  constructor() {}

  public get version() {
    return this._VERSION;
  }

  public isSessionActive(): boolean {
    this.getLocalStorageSessionInfo();
    return this.sessionUser && this.sessionToken ? true : false;
  }

  private getLocalStorageSessionInfo() {
    this.sessionUser = localStorage.user
      ? JSON.parse(localStorage.user)
      : this.sessionUser;
    this.sessionToken = localStorage.token
      ? localStorage.token
      : this.sessionToken;
    this.userClaims = localStorage.claims
      ? localStorage.claims
      : this.userClaims;
  }

  // Devuelve false a partir de 1376
  public isSmallScreen(): boolean {
    return this.smallScreen;
  }
}
